import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { INewBusinessModel } from '../../../businesses/business/new-business.model';
import { AuthConsoleApiService } from '../../../shared/services/auth-console-api/auth-console-api.service';
import { BusinessService } from '../../../shared/services/business/business.service';
import { Region } from '../../../shared/services/holdings/models/region.enum';
import { MessageService } from '../../../shared/services/message/message.service';
import { UserService } from '../../../shared/services/user/user.service';
import { GatekeeperModalComponent } from '../../modal.component';

@Component({
  selector: 'gk-add-business-modal',
  templateUrl: './add-business-modal.component.html'
})
export class AddBusinessModalComponent extends GatekeeperModalComponent<AddBusinessModalComponent> {
  newBusiness: INewBusinessModel = <INewBusinessModel>{
    regionId: Region.England
  };

  constructor(
    private businessService: BusinessService,
    private messageService: MessageService,
    private authConsoleApiService: AuthConsoleApiService,
    private userService: UserService,
    private router: Router,
    public dialogRef: MatDialogRef<AddBusinessModalComponent>
  ) {
    super();
  }

  saveBusiness() {
    // Delete business if there is an error and the business has been created.
    return this.businessService
      .addBusiness(this.newBusiness)
      .then(() => this.businessService.loadBusinessSummaries())
      .then(() =>
        this.authConsoleApiService.fetchUser(this.userService.user.authId)
      )
      .then(() => this.messageService.showIcon(MessageTypeEnum.Success))
      .catch(r =>
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          r.error.detail,
          { name: '' }
        )
      )
      .then(() => this.close())
      .then(() => this.router.navigate(['/setup/businesses']));
  }
}
